import { useNavigate, useParams } from "react-router-dom";
import ButtonComponent from "../../../../components/button/button";
import { useState, useEffect } from "react";
import InputComponent from "../../../../components/input/input";
import { getMe, getUserById, updateUser } from "../../../../features/search/service/user-service";
import { getNonSuperAdminRoles, getRoles } from "../../../../features/search/service/role-service";
import { SelectOption } from "../../../../shared/types/select-options";
import { User } from "../../../../shared/types/user";
import SelectComponent from "../../../../components/input/select";
import { MenuTop } from '../../../../components/menu/top/menu-top';
import './styles/edit.css';
import ButtonSecondaryComponent from "../../../../components/button-secondary/button";
import { ROLES } from "../../../../shared/consts/roles";
import { getCompaniesListSelect } from "../../../../features/search/service/company-service";

export const AdminUsersEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    
    const [name, setName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [roleId, setRoleId] = useState<string>('');
    const [companyId, setCompanyId] = useState<string>('');
    const [me, setMe] = useState<User | null>(null);
    const [userToEdit, setUserToEdit] = useState<User | null>(null);
    const [roles, setRoles] = useState<SelectOption[]>([]);
    const [companies, setCompanies] = useState<SelectOption[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [fetchingUser, setFetchingUser] = useState<boolean>(true);

    // Buscar dados do usuário logado
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userData = await getMe();
                setMe(userData);
            } catch (error) {
                console.error('❌ Erro ao buscar dados do usuário:', error);
            }
        };
        fetchUser();
    }, []);

    // Buscar dados do usuário a ser editado
    useEffect(() => {
        const fetchUserToEdit = async () => {
            if (!id) {

                navigate('/admin-painel');
                return;
            }

            try {
                setFetchingUser(true);
                const userData = await getUserById(id);

                console.log(userData)
                
                if (!userData) {
                    console.error('❌ Usuário não encontrado');
                    navigate('/admin-painel');
                    return;
                }

                setUserToEdit(userData);
                setName(userData.name || '');
                setEmail(userData.email || '');
                setRoleId(userData.role?.id ? String(userData.role.id) : '');
                setCompanyId(userData.company?.id ? String(userData.company.id) : '');
            } catch (error) {
                console.error('❌ Erro ao buscar usuário para editar:', error);
                navigate('/admin-painel');
            } finally {
                setFetchingUser(false);
            }
        };

        fetchUserToEdit();
    }, [id, navigate]);

    // Buscar roles disponíveis
    useEffect(() => {
        const fetchRoles = async () => {
            if (!me) {
                return;
            }

            try {
                let rolesData: SelectOption[] = [];

                if (me.role?.description === ROLES.SUPER_ADMIN) {
                    rolesData = await getRoles();
                } else if (me.role?.description === ROLES.ADMIN) {
                    rolesData = await getNonSuperAdminRoles();
                }
                
                if (!rolesData || rolesData.length === 0) {
                    return;
                }

                // Se roleId ainda não foi definido (usuário sendo carregado), define o primeiro
                if (!roleId && rolesData.length > 0) {
                    const firstRole = rolesData[0];
                    const firstRoleId = String(firstRole.id);
                    setRoleId(firstRoleId);
                }
            } catch (error) {
                console.error('❌ Erro ao buscar roles:', error);
            }
        };

        const fetchCompanies = async () => {
            if (!me) {
                return;
            }

            try {
                let companiesData: SelectOption[] = [];

                if (me.role?.description === ROLES.SUPER_ADMIN) {
                    companiesData = await getCompaniesListSelect();
                } else if (me.role?.description === ROLES.ADMIN) {
                    companiesData = await getCompaniesListSelect();
                }
                
                if (!companiesData || companiesData.length === 0) {
                    return;
                }

                setCompanies(companiesData);

                if (!companyId && companiesData.length > 0) {
                    const firstCompany = companiesData[0];
                    const firstCompanyId = String(firstCompany.id);
                    setCompanyId(firstCompanyId);
                }
            } catch (error) {
                console.error('❌ Erro ao buscar empresas:', error);
            }
        };

        fetchRoles();
        fetchCompanies();
    }, [me, roleId]);

    const handleUpdateUser = async () => {
        if (!id) {
            console.error('❌ ID do usuário não fornecido');
            return;
        }

        if (!name || name.trim() === '') {
            console.error('❌ Nome é obrigatório');
            return;
        }

        if (!email || email.trim() === '') {
            console.error('❌ Email é obrigatório');
            return;
        }

        if (!roleId || roleId === '' || roleId === 'undefined') {
            console.error('❌ Role é obrigatória');
            return;
        }

        if (!me?.company?.id && !companyId) {
            console.error('❌ Company ID é obrigatório');
            return;
        }

        const payload: any = {
            name: name.trim(),
            email: email.trim(),
            roleId: roleId,
            companyId: companyId || me?.company?.id,
        };


        setLoading(true);

        try {
            const updatedUser = await updateUser(id, payload);
            
            if (updatedUser) {
                navigate('/admin-painel/users');
            }
            
        } catch (error) {
            console.error('❌ Erro ao atualizar usuário:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        navigate('/admin-painel/users');
    };

    if (fetchingUser) {
        return (
            <div>
                <MenuTop />
                <div className="edit-user-container">
                    <p style={{ color: '#666', fontSize: '16px' }}>
                        Carregando dados do usuário...
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div>
            <MenuTop />
            <div className="edit-user-container">
                <h1>Editar Usuário</h1>

                <InputComponent
                    id="id-input-name"
                    label="Nome"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                />
                
                <InputComponent
                    id="id-input-email"
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                />

                {me?.role?.description === ROLES.SUPER_ADMIN && (
                    // <InputComponent
                    //     id="id-input-company"
                    //     label="Company ID"
                    //     value={companyId}
                    //     onChange={(event) => setCompanyId(event.target.value)}
                    // />

                    <SelectComponent
                        label="Empresa"
                        value={companyId || ''}
                        onChange={(value) => {
                            const stringValue = String(value);
                            setCompanyId(stringValue);
                        }}
                        options={companies}
                        styles={{ marginTop: '10px' }}
                    />
                )}

                {roles.length > 0 ? (
                    <SelectComponent
                        label="Função"
                        value={roleId || ''}
                        onChange={(value) => {
                            const stringValue = String(value);
                            setRoleId(stringValue);
                        }}
                        options={roles}
                        styles={{ marginTop: '10px' }}
                    />
                ) : (
                    <p style={{ color: '#666', fontSize: '14px', marginTop: '10px' }}>
                        Carregando funções...
                    </p>
                )}

                <div className="button-container">
                    <ButtonSecondaryComponent
                        label="Cancelar"
                        onClick={handleCancel}
                        disabled={loading}
                    />
                    <ButtonComponent
                        label={loading ? "Salvando..." : "Salvar Alterações"}
                        onClick={handleUpdateUser}
                        disabled={loading || !roleId || roleId === '' || roleId === 'undefined'}
                    />
                </div>
            </div>
        </div>
    );
};